import {
  FETCH_UPDATE_ENTITY_REQUEST,
  FETCH_UPDATE_ENTITY_SUCCESS,
  FETCH_UPDATE_ENTITY_FAILURE,
  SET_UPDATE_ENTITY,
} from "../../actions/entities/update-entity-actions";

const initialState = {
  entity: {},
  isLoading: false,
  error: null,
};

const UpdateEntityReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_UPDATE_ENTITY_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_UPDATE_ENTITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entity: { ...action.payload },
      };
    case SET_UPDATE_ENTITY:
      return {
        ...state,
        isLoading: false,
        error: null,
        entity: { ...action.payload },
      };
    case FETCH_UPDATE_ENTITY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default UpdateEntityReducer;
